function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { callPrivateApiAction } from "./api";
/*******************
 * ACTIONS
 *******************/ export var etransportActions = {
    downloadDeclarationPdf: function downloadDeclarationPdf(param, abortControllerSignal) {
        var myCompanyId = param.myCompanyId, declarationId = param.declarationId;
        return callPrivateApiAction("get", "/v1/my-companies/".concat(myCompanyId, "/etransport/").concat(declarationId, "/download"), null, {
            signal: abortControllerSignal
        });
    },
    sendDeclarationByEmail: function sendDeclarationByEmail(param, abortControllerSignal) {
        var myCompanyId = param.myCompanyId, declarationId = param.declarationId, data = param.data;
        return callPrivateApiAction("post", "/v1/my-companies/".concat(myCompanyId, "/etransport/").concat(declarationId, "/send-by-email"), data, {
            signal: abortControllerSignal
        });
    },
    createETransportDeclaration: function createETransportDeclaration(param, abortControllerSignal) {
        var myCompanyId = param.myCompanyId, data = param.data;
        return callPrivateApiAction("post", "/v1/my-companies/".concat(myCompanyId, "/etransport/declarations"), data, {
            signal: abortControllerSignal
        });
    },
    getEtransportDeclarationPreview: function getEtransportDeclarationPreview(param, abortControllerSignal) {
        var myCompanyId = param.myCompanyId, declarationId = param.declarationId;
        return callPrivateApiAction("get", "/v1/my-companies/".concat(myCompanyId, "/etransport/").concat(declarationId, "/preview"), null, {
            signal: abortControllerSignal
        });
    },
    updateETransportDeclaration: function updateETransportDeclaration(param, abortControllerSignal) {
        var myCompanyId = param.myCompanyId, data = param.data, declarationId = param.declarationId;
        return callPrivateApiAction("put", "/v1/my-companies/".concat(myCompanyId, "/etransport/").concat(declarationId, "/declarations"), data, {
            signal: abortControllerSignal
        });
    },
    createETransportVehicleModification: function createETransportVehicleModification(param, abortControllerSignal) {
        var myCompanyId = param.myCompanyId, values = param.values;
        return callPrivateApiAction("post", "/v1/my-companies/".concat(myCompanyId, "/etransport/vehicle-modifications"), values, {
            signal: abortControllerSignal
        });
    },
    updateETransportVehicleModification: function updateETransportVehicleModification(param, abortControllerSignal) {
        var eventId = param.eventId, myCompanyId = param.myCompanyId, values = param.values;
        return callPrivateApiAction("put", "/v1/my-companies/".concat(myCompanyId, "/etransport/").concat(eventId, "/vehicle-modifications"), values, {
            signal: abortControllerSignal
        });
    },
    createETransportTransportConfirmation: function createETransportTransportConfirmation(param, abortControllerSignal) {
        var myCompanyId = param.myCompanyId, values = param.values;
        return callPrivateApiAction("post", "/v1/my-companies/".concat(myCompanyId, "/etransport/transport-confirmations"), values, {
            signal: abortControllerSignal
        });
    },
    updateETransportTransportConfirmation: function updateETransportTransportConfirmation(param, abortControllerSignal) {
        var eventId = param.eventId, myCompanyId = param.myCompanyId, values = param.values;
        return callPrivateApiAction("put", "/v1/my-companies/".concat(myCompanyId, "/etransport/").concat(eventId, "/transport-confirmation"), values, {
            signal: abortControllerSignal
        });
    },
    listEtransport: function listEtransport(myCompanyId, param, abortControllerSignal) {
        var page = param.page, perPage = param.perPage, sortBy = param.sortBy, sortDir = param.sortDir, search = param.search, filters = param.filters;
        var params = {
            page: page,
            perPage: perPage,
            sortBy: sortBy,
            sortDir: sortDir
        };
        if (search) {
            params.search = search;
        }
        if (filters) {
            params.filters = filters;
        }
        return callPrivateApiAction("get", "/v1/my-companies/".concat(myCompanyId, "/etransport"), params, {
            signal: abortControllerSignal
        });
    },
    cancelEtransportDeclaration: function cancelEtransportDeclaration(param, abortControllerSignal) {
        var myCompanyId = param.myCompanyId, eventId = param.eventId;
        return callPrivateApiAction("delete", "/v1/my-companies/".concat(myCompanyId, "/etransport/").concat(eventId, "/declarations"), null, {
            signal: abortControllerSignal
        });
    },
    getEtransportEventById: function getEtransportEventById(param, abortControllerSignal) {
        var myCompanyId = param.myCompanyId, eventId = param.eventId;
        return function(dispatch) {
            return dispatch(callPrivateApiAction("get", "/v1/my-companies/".concat(myCompanyId, "/etransport/").concat(eventId), null, {
                signal: abortControllerSignal
            })).then(function(response) {
                return response.body;
            });
        };
    },
    getEtransportDeclarationById: function getEtransportDeclarationById(param, abortControllerSignal) {
        var myCompanyId = param.myCompanyId, eventId = param.eventId;
        var _this = this;
        return /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(dispatch) {
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                dispatch(_this.getEtransportEventById({
                                    myCompanyId: myCompanyId,
                                    eventId: eventId
                                }, abortControllerSignal))
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            });
            return function(dispatch) {
                return _ref.apply(this, arguments);
            };
        }();
    },
    getEtransportVehicleModificaitonById: function getEtransportVehicleModificaitonById(param, abortControllerSignal) {
        var myCompanyId = param.myCompanyId, eventId = param.eventId;
        var _this = this;
        return /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(dispatch) {
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                dispatch(_this.getEtransportEventById({
                                    myCompanyId: myCompanyId,
                                    eventId: eventId
                                }, abortControllerSignal))
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            });
            return function(dispatch) {
                return _ref.apply(this, arguments);
            };
        }();
    },
    getEtransportTransportConfirmationById: function getEtransportTransportConfirmationById(param, abortControllerSignal) {
        var myCompanyId = param.myCompanyId, eventId = param.eventId;
        var _this = this;
        return /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(dispatch) {
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                dispatch(_this.getEtransportEventById({
                                    myCompanyId: myCompanyId,
                                    eventId: eventId
                                }, abortControllerSignal))
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            });
            return function(dispatch) {
                return _ref.apply(this, arguments);
            };
        }();
    },
    deleteEtransportEvent: function deleteEtransportEvent(param, abortControllerSignal) {
        var myCompanyId = param.myCompanyId, eventId = param.eventId;
        return callPrivateApiAction("delete", "/v1/my-companies/".concat(myCompanyId, "/etransport/").concat(eventId), null, {
            signal: abortControllerSignal
        });
    },
    deleteEtransportDeclaration: function deleteEtransportDeclaration(param, abortControllerSignal) {
        var myCompanyId = param.myCompanyId, eventId = param.eventId;
        var _this = this;
        return /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(dispatch) {
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                dispatch(_this.deleteEtransportEvent({
                                    myCompanyId: myCompanyId,
                                    eventId: eventId
                                }, abortControllerSignal))
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            });
            return function(dispatch) {
                return _ref.apply(this, arguments);
            };
        }();
    },
    deleteEtransportTransportConfirmation: function deleteEtransportTransportConfirmation(param, abortControllerSignal) {
        var myCompanyId = param.myCompanyId, eventId = param.eventId;
        var _this = this;
        return /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(dispatch) {
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                dispatch(_this.deleteEtransportEvent({
                                    myCompanyId: myCompanyId,
                                    eventId: eventId
                                }, abortControllerSignal))
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            });
            return function(dispatch) {
                return _ref.apply(this, arguments);
            };
        }();
    },
    deleteEtransportVehicleModification: function deleteEtransportVehicleModification(param, abortControllerSignal) {
        var myCompanyId = param.myCompanyId, eventId = param.eventId;
        var _this = this;
        return /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(dispatch) {
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                dispatch(_this.deleteEtransportEvent({
                                    myCompanyId: myCompanyId,
                                    eventId: eventId
                                }, abortControllerSignal))
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            });
            return function(dispatch) {
                return _ref.apply(this, arguments);
            };
        }();
    },
    sendToEtransport: function sendToEtransport(param, abortControllerSignal) {
        var myCompanyId = param.myCompanyId, eventId = param.eventId;
        return callPrivateApiAction("post", "/v1/my-companies/".concat(myCompanyId, "/etransport/").concat(eventId, "/send-to-etransport"), null, {
            signal: abortControllerSignal
        });
    },
    downloadEtransportXml: function downloadEtransportXml(param, abortControllerSignal) {
        var myCompanyId = param.myCompanyId, eventId = param.eventId;
        return callPrivateApiAction("get", "/v1/my-companies/".concat(myCompanyId, "/etransport/").concat(eventId, "/download-xml"), null, {
            signal: abortControllerSignal,
            rawResponse: true,
            responseType: "blob"
        });
    }
};
